import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import styles from "./ListMustSellSkuPage.module.scss";

// Actions
import { TextField, ButtonGroup, Button, Grid } from "@material-ui/core";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { getIcon } from "../../../icon/icon";
import {
  createMustSellSku,
  removeMustSellSkus
} from "../../../state/actions/MustSellActions";
import { getMustSellSkus } from "../../../state/actions/MustSellActions";
import { NewEntityDialog } from "../../../containers/new-entity-dialog/NewEntityDialog";
import { DeleteModal } from "../../../containers/delete-modal/DeleteModal";
import PageContainer from "../../../components/page-container/PageContainer";
import Search from "../../../components/search/Search";
import { withTranslation } from "react-i18next";

class ListMustSellSkuPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      originalData: [],
      searchedData: [],
      mustSells: {},
      addMustSellModalOpen: false,
      newMustSellSkuTitle: "",
      deleteAlertShowing: false,
      selectedItems: [],
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.getMustSellSkus(() => {
      this.setState({ loading: false });
    });

    this.setupData();
  }

  componentDidUpdate() {
    this.setupData();
  }

  setupData() {
    if (
      JSON.stringify(this.state.mustSells) !==
      JSON.stringify(this.props.mustSells)
    ) {
      const data = this.createData(this.props.mustSells);

      this.setState({
        originalData: data,
        searchedData: data,
        mustSells: this.props.mustSells
      });
    }
  }

  createData(mustSells) {
    const mustSellKeys = Object.keys(mustSells);

    return mustSellKeys.map(mustSellKey => {
      const mustSell = mustSells[mustSellKey];
      return {
        id: mustSell.id,
        name: mustSell.Name,
        attachedGroups: mustSell.ProductGroups.length
      };
    });
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      cell.handleClick = (event, row) => {
        this.props.history.push(`/must-sell-skus/${row.id}`);
      };

      cell.align = header.align;
      cell.clickable = header.clickable;
      cell.type = header.type;

      cells.push(cell);
    });

    return cells;
  }

  search(searchText) {
    const text = searchText.toLowerCase();

    if (text === "") {
      this.setState({ searchedData: this.state.originalData });
    }

    const foundData = this.state.originalData.filter(data => {
      return data.id.toLowerCase().includes(text);
    });

    this.setState({ searchedData: foundData });
  }

  createHeaders() {
    return [
      {
        id: "name",
        clickable: true,
        align: "left",
        label: this.props.t('common.name'),
        type: "label"
      },
      {
        id: "id",
        clickable: false,
        align: "left",
        label: this.props.t('must-sell.id'),
        type: "label"
      },
      {
        id: "attachedGroups",
        clickable: false,
        align: "left",
        label: this.props.t('master-tag.attached-groups'),
        type: "label"
      }
    ];
  }

  renderTable() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.state.searchedData.length > 0) {
      return (
        <SimpleTable
          isSelectable={true}
          handleSelection={selectedItems => this.setState({ selectedItems })}
          dataId={"id"}
          cells={cells}
          headers={headers}
          rows={this.state.searchedData}
        />
      );
    } else {
      return (
        <PagePlaceholder
          image={getIcon("bolt.svg")}
          text={this.props.t('must-sell.none-found')}
        />
      );
    }
  }

  handleCreate() {
    this.props.createMustSellSku(this.state.newMustSellSkuTitle, () => {
      this.setState({ addMustSellModalOpen: false });
    });
  }

  generateDeletedItems() {
    let deletedItems = [];

    this.state.selectedItems.forEach((selectedItemId) => {
      const mustSell = this.props.mustSells[selectedItemId];

      if (mustSell !== undefined) {
        deletedItems.push({ id: mustSell.id, Name: mustSell.Name });
      }
    });

    return deletedItems;
  }

  render() {
    const loading = <Loading />;

    return (
      <div>
        <NewEntityDialog
          onTitleChange={title => this.setState({ newMustSellSkuTitle: title })}
          confirmLabel={this.props.t("must-sell.new")}
          dialogTitle={this.props.t('must-sell.new')}
          isOpen={this.state.addMustSellModalOpen}
          onConfirm={() => this.handleCreate()}
          onCancel={() => this.setState({ addMustSellModalOpen: false })}
        />
        <DeleteModal
          handleCancel={() => {
            this.setState({
              deleteAlertShowing: false,
              selectedItems: []
            });
          }}
          handleDone={data => {
            this.props.removeMustSellSkus(data.map((i) => i.id), () => {
              this.setState({
                deleteAlertShowing: false,
                selectedItems: []
              });
            });
          }}
          data={this.generateDeletedItems()}
          open={this.state.deleteAlertShowing}
        />
        <BreadcrumbsItem to="/must-sell-skus">Must Sell SKUs</BreadcrumbsItem>
        <HeaderBlock
          title={this.props.t('must-sell.must-sell-skus')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <Search
                  searchField={"name"}
                  secondaryFields={["id"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('must-sell.search')}
                />
              </Grid>
              <Grid item>
                <ButtonGroup>
                  <Button
                    disabled={this.state.selectedItems.length === 0}
                    onClick={() => this.setState({ deleteAlertShowing: true })}
                    variant="outlined"
                    color="primary"
                  >
                    {this.props.t('common.delete')}
                  </Button>
                  <Button
                    onClick={() => this.setState({ addMustSellModalOpen: true })}
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('must-sell.new')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
        />
        <PageContainer hasFooter>
          {this.state.loading ? loading : this.renderTable()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { mustSells } = state.MustSellReducer;
  return { mustSells };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getMustSellSkus, createMustSellSku, removeMustSellSkus },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListMustSellSkuPage))
);

// EXPORT COMPONENT

export { hoc as ListMustSellSkuPage };
